import api from './api';
import { AMENITY } from './endpoints';

const get = () => api.get(`${AMENITY}/`);

export default {
  get,
};
